/**
 * K&J B2B (30/10/2026, entrée 534) : plus de page panier, tout passe par le tiroir.
 * Demande de Joachim : la page /cart est une étape inutile avant le paiement.
 *  1. Tout lien du site vers /cart (icône, « Voir le panier », messages…) ouvre le tiroir au lieu de changer de page.
 *  2. Arrivée sur une page avec #panier (renvoi depuis /cart, voir layout/theme.liquid) : le tiroir s'ouvre tout seul.
 * Sans tiroir sur la page, rien n'est intercepté : le lien mène à /cart comme avant.
 */
import { ThemeEvents } from '@theme/events';

const tiroir = () => document.querySelector('cart-drawer');
const ouvrir = () => document.dispatchEvent(new Event(ThemeEvents.cartOpen));
const cheminPanier = ((window.Theme && window.Theme.routes && window.Theme.routes.cart_url) || '/cart').replace(/\/$/, '');

document.addEventListener('click', (e) => {
  if (e.defaultPrevented || e.button !== 0 || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;
  const a = e.target.closest('a[href]');
  if (!a || a.target === '_blank' || a.hasAttribute('download')) return;
  let url;
  try { url = new URL(a.href, window.location.href); } catch (err) { return; }
  if (url.origin !== window.location.origin) return;
  if (url.pathname.replace(/\/$/, '') !== cheminPanier) return;
  if (!tiroir()) return;
  e.preventDefault();
  ouvrir();
}, true);

if (window.location.hash === '#panier') {
  history.replaceState(null, '', window.location.pathname + window.location.search);
  const essai = () => (tiroir() ? ouvrir() : null);
  if (document.readyState === 'complete') setTimeout(essai, 50);
  else window.addEventListener('load', () => setTimeout(essai, 50));
}
